export default "__VITE_ASSET__BZbekoI5__"